import { Dictionary } from '@domain/types/common/dictionary';
import gem1 from './gem1.png';
import gem2 from './gem2.png';
import gem3 from './gem3.png';
import gem4 from './gem4.png';
import gem5 from './gem5.png';
import iconcoins from './iconcoins.png';

const all: Dictionary<string> = { gem1, gem2, gem3, gem4, gem5, iconcoins };

export default all;
